import { getSimpleDateFromISOString, getSimpleHoursMinutesFromISOString } from './dateFunctions';

export function getUniqueDataDays(origTypeReadings): [] {
  const dayCount = [];
  let currentDate = '';

  origTypeReadings.length > 0 && origTypeReadings.forEach((reading): [] => {
    currentDate = getSimpleDateFromISOString(reading.dateTime);
    dayCount.push(currentDate);
  });
  // convert to a Set to remove duplicates
  let s = new Set(dayCount);
  // convert back to an array to return
  return [...s];
}


// One date only in the array
export function arrayFunctionForTypeDateGraph(origTypeReadings, origType): [] {
  const readingArray = createIncrementedArray(origType);
  const delay = addDelay(origType);
  drawAllReadingsOnGraph(origTypeReadings, origType, delay, readingArray);
  return readingArray;
}

export function arrayFunctionForDashboardGraph(origTypeReadings, types): [] {
  const readingArray = createIncrementedArrayForMultipleTypes(types);
  let delay = 0;
  types.forEach((origType) => {
    delay = addDelay(origType);
    drawAllReadingsOnGraph(origTypeReadings, origType, delay, readingArray);
  });
  return readingArray;
}


/** NOT EXPORTED FUNCTIONS **/

function drawAllReadingsOnGraph(origTypeReadings, origType, delay, readingArray) {
  let valueToSearch = '';
  let foundIndex = 0;
  let readingAmount = 0;
  let halflifeArray = [];
  origTypeReadings.length > 0 && origTypeReadings.forEach((reading) => {
    valueToSearch = getSimpleHoursMinutesFromISOString(reading.dateTime);
    foundIndex = readingArray.findIndex(elem => elem.time === valueToSearch);
    if (reading.typeId === origType._id) {
      if (origType.reductionHalflife > 0) {
        readingAmount = reading.activeAmount;
        halflifeArray = createIncrementedArray(origType);
      } else {
        readingArray[foundIndex][origType.name] += reading.activeAmount;
      }
    }
    if (origType.reductionHalflife > 0) {
      halflife(foundIndex, halflifeArray, origType, delay, readingAmount, readingArray);
    }
  });

  if (origType.reductionPerHour > 0) {
    perHour(origType, readingArray, delay);
  }
}

function halflife(foundIndex, halflifeArray, origType, delay, readingAmount, readingArray) {
  let reduced = 0;
  for (let i = foundIndex; i < 144; i++) {
    if (halflifeArray.length > 0) {
      halflifeArray[i][origType.name] = readingAmount;
      reduced = halflifeReduction(origType, foundIndex, i, delay, readingAmount, halflifeArray);
      halflifeArray[i][origType.name] -= reduced;
      readingArray[i][origType.name] += halflifeArray[i][origType.name];
    }
  }
}

function halflifeReduction(origType, foundIndex, i, delay, readingAmount, halflifeArray) {
  const increments = Math.round(origType.reductionHalflife / 10);
  let reduced = 0;
  if (i > (foundIndex + delay)) {
    let whichIteration = Math.ceil((i - foundIndex - delay) / increments) - 1;
    let startingAmount = halflifeArray[foundIndex + delay + (increments * whichIteration)][origType.name];
    let halflifeReduction = startingAmount / 2;
    let alreadyReduced = readingAmount - startingAmount;
    let reduceNow = (halflifeReduction * (i - foundIndex - delay - (increments * whichIteration)) / increments);
    reduced = alreadyReduced + reduceNow;
  }
  return reduced;
}


function perHour(origType, readingArray, delay) {
  const incrementsPerHour = 6;
  let first = 0;
  let prev = 0;
  let reduced = (origType.reductionPerHour / incrementsPerHour);

  for (let i = 0; i < 144; i++) {
    if (first === 0 && readingArray[i][origType.name] > 0) {
      first = i;
      prev = readingArray[i][origType.name];
      continue;
    } else if (readingArray[i][origType.name] > 0) {
      prev += readingArray[i][origType.name];
    } else if (delay > i - first) {
      readingArray[i][origType.name] = prev;
      continue;
    } else if (first === 0 && readingArray[i][origType.name] === 0) {
      continue;
    }

    readingArray[i][origType.name] = prev - reduced;
    prev = readingArray[i][origType.name];
    if (readingArray[i][origType.name] <= 0 && first !== 0) {
      readingArray[i][origType.name] = 0;
      first = 0;
    }
  }
}

function createIncrementedArray(origType) {
  // Get data in a better format for a graph, i.e. regular intervals on X-axis
  const readingArray = [];
  for (let i = 0; i < 144; i++) {
    let simpleTime = 10 * i;
    let simpleHours = Math.floor(simpleTime / 60);
    let simpleMinutes = simpleTime % 60;
    let simpleCombinedHoursMinutes = simpleHours + ':' + simpleMinutes;
    readingArray.push({ [origType.name]: 0, minutes: simpleTime, time: simpleCombinedHoursMinutes });
  }
  return readingArray;
}

function createIncrementedArrayForMultipleTypes(types) {
  // Get data in a better format for a graph, i.e. regular intervals on X-axis
  const readingArray = [];
  for (let i = 0; i < 144; i++) {
    let simpleTime = 10 * i;
    let simpleHours = Math.floor(simpleTime / 60);
    let simpleMinutes = simpleTime % 60;
    let simpleCombinedHoursMinutes = simpleHours + ':' + simpleMinutes;
    readingArray.push({ minutes: simpleTime, time: simpleCombinedHoursMinutes });
    for (let j = 0; j < types.length; j++) {
      readingArray[i][types[j].name] = 0;
    }
  }
  return readingArray;
}

function addDelay(origType) {
  let delay = 0;
  if (origType.reductionDelay > 0) {
    // Add a delay
    delay = Math.round(origType.reductionDelay / 10);
  }
  return delay;
}


